export default __webpack_public_path__ + "static/upper4_1-1b23065728cee3aa5c455a3aa5553b7e.jpg";